import {Modal} from '@/components/ui/modal/Modal'
import {useRootStore} from '@/store'
import {selectMeetMoreHostModal} from '@/store/selectors'
import {useMe} from '../authentication/queries/useMe'
import {useTranslation} from 'react-i18next'
import {
    StyledDivider,
    StyledMaskDiv,
    StyledModalContainer,
    StyledSubTitleWrapper,
    StyledSvgContainer,
    StyledTitleWrapper
} from './style'
import {Bubble} from '@/assets/icons/icons'
import {Button} from '@/components/ui/button/Button'
import MeetRookies from '@/assets/images/MeetRookies.png'
import {LocalStorageManager} from '@/utilities/localStorage'
import {useGetCreatorProfile} from '../guest/queries/useGetCreatorProfile'

export const MeetMoreHostModal = () => {
    const {data: user} = useMe()
    const {t} = useTranslation()
    const referredBy = user?.referredBy
    const {closeModal} = useRootStore(selectMeetMoreHostModal)
    const {data: host} = useGetCreatorProfile({creatorIdentifier: referredBy?.toString() ?? null})

    const handleCloseModal = () => {
        LocalStorageManager.guestReferralModal.set(true)
        closeModal()
    }

    return (
        <Modal title={t('meet_more_rookie:modal_title')} onClose={handleCloseModal}>
            <StyledModalContainer>
                <StyledTitleWrapper>
                    <h1>
                        {t('meet_more_rookie:title', {USERNAME: ''})}
                        <br />
                        <span>{host?.fullName}</span>
                    </h1>
                </StyledTitleWrapper>
                <StyledSvgContainer>
                    <StyledMaskDiv
                        style={{
                            backgroundImage: `url(${host?.avatar?.url ?? MeetRookies})`
                        }}
                    />
                    <Bubble />
                </StyledSvgContainer>
                <StyledSubTitleWrapper>
                    <p>{t('meet_more_rookie:subtitle', {USERNAME: ''})}</p>
                    <StyledDivider />
                    <Button onClick={handleCloseModal}>
                        {t('meet_more_rookie:main_cta', {USERNAME: host?.fullName})}
                    </Button>
                </StyledSubTitleWrapper>
            </StyledModalContainer>
        </Modal>
    )
}
